import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SharedSpecificQuestionnaireService {
  extractRouteParams(params: { [key: string]: string | undefined }) {
    const cropFieldId = Number.parseInt(params['cropFieldId'] || '0', 10);
    const cropYear = Number.parseInt(params['cropYear'] || new Date().getFullYear().toString(), 10);
    return { cropFieldId, cropYear };
  }

  validateRouteParams(params: { cropFieldId: number; cropYear: number }) {
    return !Number.isNaN(params.cropFieldId) && !Number.isNaN(params.cropYear);
  }
}
